const RESOURCE = {
    'loanapphome.ppdai.com-home': [
        'widgetwebui',
        'widgetframe',
        'widgettool'
    ],
    'loanapphome.ppdai.com-account': [
        'widgetwebui',
        'widgetframe',
        'widgettool'
    ],
    'loanweblocal.ppdai.com-home': [
        'widgetwebui',
        'widgetframe',
        'widgettool'
    ],
    'loanappexp.ppdai.com': [
        'widgetwebui',
        'widgetframe',
        'widgettool'
    ]
};

export default RESOURCE;